function getStep(value) {
  if (value < 1000) return 100;          // 0 – 1,000
  if (value < 10000) return 1000;         // 1,000 – 10,000
  if (value < 100000) return 5000;       // 10,000 – 1,00,000
  if (value < 1000000) return 50000;      // 1,00,000 – 10,00,000
  if (value < 10000000) return 100000;    // 10,00,000 – 1,00,00,000
  return 500000;                         // 1,00,00,000+
}

function generateSequence(minAmt, maxAmt) {
  const seq = [];
  let start = minAmt <= 100 ? 100 : minAmt;

  while (start <= maxAmt) {
    seq.push(start);
    start += getStep(start);
  }

  return seq;
}

export function generatePurchaseDropdownOptions(minAmt, multiple, maxAmt) {
  const baseSeq = generateSequence(minAmt, maxAmt);
  const options = [""];
  if (multiple > 0) {
    for (let i = 0; i < baseSeq.length; i++) {
      if ((baseSeq[i] - baseSeq[0]) % multiple === 0 || baseSeq[i] === maxAmt) {
        options.push(baseSeq[i]);
      }
    }
  } else {
    options.push(...baseSeq);
  }

  return options;
}

export function generateRedemptionDropdownOptions(minAmt, multiple, maxAmt) {
  const baseSeq = generateSequence(minAmt, maxAmt);
  const options = ["", "ALL"];

  if (multiple > 0) {
    for (let i = 0; i < baseSeq.length; i++) {
      if ((baseSeq[i] - baseSeq[0]) % multiple === 0 || baseSeq[i] === maxAmt) {
        options.push(baseSeq[i]);
      }
    }
  } else {
    options.push(...baseSeq);
  }

   if (!options.includes(maxAmt)) {
    options.push(maxAmt);
  }
  
  return options;
}

export function generateInstallmentsDropdownOptions(minInt, multiple, maxInt) {
  const options = [];

  // Add "All Units" first
  options.push("");
  options.push("Until cancelled");

  // Ensure at least 500 for minimum start
  // let start = minAmt <= 1000 ? 1000 : minAmt;
  let start = minInt;

  // Nearest value below maxAmt using your dynamic step logic
  while (start <= maxInt) {
    options.push(start);

    // Decide step (multiple) dynamically
    let step;
    step = multiple;

    // Stop before exceeding the nearest rounded-down value
    if (start + step > maxInt) break;

    start += step;
  }

  // Add exact maxAmt if not already included
  if (options[options.length - 1] !== maxInt) {
    options.push(maxInt);
  }

  return options;
}

export const getSipDateOptions = (sipDatesString) => {
  if (!sipDatesString) return ["", "Earliest"];

  const dates = sipDatesString
    .split(",")
    .map(date => Number(date))
    .filter(num => !isNaN(num))
    .sort((a, b) => a - b);

  return ["", "Earliest", ...dates];
};
export const getSipDates = (sipDatesString) => {
  if (!sipDatesString) return [];

  const dates = sipDatesString
    .split(",")
    .map(date => Number(date))
    .filter(num => !isNaN(num))
    .sort((a, b) => a - b);

  return [...dates];
};

export function getNextSipInstallmentDate({ isin, day, month, year, desirableDay, sipDates }) {
  // sipDates: array of numbers, e.g., [1, 5, 10, 15, 20, 25]
  // desirableDay: number (1–28) or "Earliest"

  const startDate = new Date(year, month - 1, day); // JS month is 0-based

  // Generate available SIP dates for the next 1 year
  const availableDates = [];
  let tempDate = new Date(startDate);
  const endDate = new Date(startDate);
  endDate.setFullYear(endDate.getFullYear() + 1);

  while (tempDate < endDate) {
    const d = tempDate.getDate();
    if (sipDates.includes(d)) {
      availableDates.push(new Date(tempDate));
    }
    tempDate.setDate(tempDate.getDate() + 1);
  }

  // Step 1: Start from +15 days (instead of 30/31)
  let installmentDate = new Date(startDate);
  installmentDate.setDate(installmentDate.getDate() + 15);

  if (desirableDay === "Earliest") {
    // Avoid 29/30/31 and push to 1st if needed
    while ([29, 30, 31].includes(installmentDate.getDate())) {
      installmentDate.setDate(installmentDate.getDate() + 1);
    }
  } else {
    desirableDay = parseInt(desirableDay, 10);
    let instDay = installmentDate.getDate();

    if (desirableDay > instDay) {
      // Same month
      installmentDate.setDate(desirableDay);
    } else {
      // Push to next month
      const temp = new Date(installmentDate);
      temp.setMonth(temp.getMonth() + 1);
      temp.setDate(desirableDay);
      installmentDate = temp;
    }
  }

  // Step 2: Align with available SIP dates
  let finalDate = availableDates.find(d => d >= installmentDate);
  if (!finalDate) {
    finalDate = availableDates[availableDates.length - 1]; // fallback
  }

  const formatDate = d => d.toLocaleDateString('en-GB'); // dd-mm-yyyy

  return {
    ISIN: isin,
    current_date: formatDate(startDate),
    desirable_installment: formatDate(finalDate)
  };
}
